const TOKEN_KEY = 'mcexchange_token'
const USER_INFO_KEY = 'mcexchange_userinfo'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}

export function getUserInfo() {
  const info = localStorage.getItem(USER_INFO_KEY)
  return info ? JSON.parse(info) : null
}

export function setUserInfo(info) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(info))
}

export function isLoggedIn() {
  return !!getToken()
}

export function getUserToken() {
  return getToken()
}

export function getStaffToken() {
  return localStorage.getItem('staff_token')
}

export function setStaffToken(token) {
  localStorage.setItem('staff_token', token)
}

export function removeStaffToken() {
  localStorage.removeItem('staff_token')
  localStorage.removeItem('staff_info')
}

export function getStaffInfo() {
  try {
    return JSON.parse(localStorage.getItem('staff_info') || '{}')
  } catch (e) {
    return {}
  }
}

export function setStaffInfo(info) {
  localStorage.setItem('staff_info', JSON.stringify(info))
}

export function getCurrentRole() {
  const hash = window.location.hash
  if (hash.includes('/yewuduan')) {
    return 'staff'
  }
  return 'user'
}
